import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class PortService {
    constructor(private http: AuthHttp) { }

    getPmoAndPorts() {
        return this.http.get('/api/pmos');
    }

    addPmo(title): Observable<Response> {
        return this.http.post('/api/pmos', { title: title })
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });
    }

    addPort(pmoId, title): Observable<Response> {
        return this.http.post('/api/ports', { officeId: pmoId, title: title })
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });
    }

    getPort(portId, year, type): Observable<Response> {
        let typeNumber = 0;
        switch (type) {
            case 'planning':
                typeNumber = 0;
                break;
            case 'navigation':
                typeNumber = 1;
                break;
            case 'sounding':
                typeNumber = 2;
                break;
            case 'google':
                typeNumber = 3;
                break;
        }

        return this.http.get('/api/ports?id=' + portId + '&year=' + year + '&type=' + typeNumber)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });
    }

    uploadPortMap(portId, year, type, image) {
        let form = new FormData();
        form.append("PortId", portId);
        form.append("Year", year);
        form.append("Type", type);
        form.append("Image", image, image.name);

        return this.http.post('/api/ports/maps', form)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });
    }

    updateGoogleMap(portId, placeId) {
        return this.http.post('/api/ports/maps/google',
            {
                PortId: portId,
                Url: placeId
            });
    }
}



// WEBPACK FOOTER //
// ./Angular/app/_services/port.service.ts